import RaQToast from "@components/common/RaQToast";
import BackButton from "@components/icons/BackButton";
import MediaAssets from "@components/utils/MediaAssets";
import { ImageDefault } from "@components/utils/Utils";
import { ITopNavigationResponse } from "@customTypes/commonResponses";
import useAppContext from "@hooks/useAppContext";
import { IRequestQuoteData } from "@hooks/useRequestQuote";
import Image from "next/legacy/image";
import InputForms from "./InputForms";
import ExitButton from '@components/icons/ExitButton'

interface IContactDetailsDesktopProps {
  onRequestOpen: ((isOpen: boolean) => void) & (() => void);
  onClick: (isOpen: boolean, isSuccessMobile?: boolean | undefined) => void;
  onRequestSubmit: (data: IRequestQuoteData) => Promise<void>;
  onBackClick: (isOpen: boolean) => void;
  topNavigation: ITopNavigationResponse | undefined;
}

function ContactDetailsDesktop({
                                 onRequestOpen,
                                 onClick,
                                 onRequestSubmit,
                                 onBackClick,
                                 topNavigation,
                               }: IContactDetailsDesktopProps): JSX.Element {
  const appContext = useAppContext();
  return (
    <>
      <div className="md:inset-0 md:h-full fixed top-0 left-0 right-0 z-[101] h-[100%] w-full overflow-y-auto overflow-x-hidden">
        <div className="md:h-auto relative h-[100%] w-full">
          {/* <!-- Modal content --> */}
          <div className="shadow dark:bg-gray-700 relative h-[100%] rounded-lg bg-white">
            {/* <!-- Modal body --> */}
            <div className="space-y-6 p-6">
              <div className="items-top flex overflow-y-auto overflow-x-hidden bg-white">
                <div className="relative aspect-auto h-[calc(100vh_-_3rem)] w-[45%]">
                  <Image
                    src={MediaAssets.getAsset("raq_step_3")}
                    layout="fill"
                    className="h-full w-full rounded-3xl object-cover"
                    alt="request a quote step 3"
                  />
                  <RaQToast/>
                </div>
                <div className="flex h-[calc(100vh_-_3rem)] w-[55%] flex-col">
                  <div className="ml-20 flex h-[calc(100vh_-_3rem)] flex-col justify-between">
                    <div className="flex w-full items-center justify-between">
                      <div>
                        <Image
                          src={ImageDefault(topNavigation?.Logo)}
                          width="142"
                          height="48"
                          layout="fixed"
                          alt="Costa Rican Vacations Logo"
                        />
                      </div>
                      <div>
                        <ExitButton onClick={onRequestOpen}/>
                      </div>
                    </div>
                    <div className="flex">
                      <div>
                        <div className="mb-3">
                          <BackButton onClick={() => onBackClick(true)}/>
                        </div>
                        <h1 className="mb-3 text-h4 font-medium">
                          Request a Custom Quote
                        </h1>
                        <div className="mb-8 text-darkgray">
                          Contact Details
                        </div>
                        <InputForms
                          onClick={onClick}
                          onRequestSubmit={onRequestSubmit}
                        />
                        <div className="mt-6">
                          <div className="flex">
                            <div className="text-p14 font-medium">
                              Already have an account?
                            </div>
                            <div
                              onClick={() => {
                                appContext?.setShowLoginModal(true);
                                onRequestOpen();
                              }}
                              className="ml-2 mb-4 cursor-pointer text-p14 font-semibold text-orange"
                            >
                              Log in
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="h-[48px]"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="absolute top-3 right-3">
        <ExitButton onClick={onRequestOpen} />
      </div> */}
      </div>
    </>
  );
}

export default ContactDetailsDesktop;
